
const config: any = {
  BACKEND_BASE_URL: import.meta.env.VITE_BACKEND_BASE_URL,
  BACKEND_TXN_BASE_URL: import.meta.env.VITE_BACKEND_TXN_BASE_URL,
  EOD_BASE_URL: import.meta.env.VITE_EOD_BASE_URL,
  REPAYMENT_BASE_URL: import.meta.env.VITE_REPAYMENT_BASE_URL,
  EOD_JOB_WAIT_TIME_IN_MINUTES: import.meta.env.VITE_EOD_JOB_WAIT_TIME_IN_MINUTES,
  EOD_PULLER_JOB_START_TIME_HOUR: import.meta.env.VITE_EOD_PULLER_JOB_START_TIME_HOUR, //use 24 hours format for setting the starting time of the job
  EOD_PULLER_JOB_START_TIME_MINUTE: import.meta.env.VITE_EOD_PULLER_JOB_START_TIME_MINUTE, //use 24 hours format for setting the starting time of the job
  GSTIN_FEATURE_FLAG: import.meta.env.VITE_GSTIN_FEATURE_FLAG,
  // BACKEND_BASE_URL:"https://503d-2405-201-2-a2f4-fcfd-c8b7-664b-86b1.in.ngrok.io", //oswald
  // BACKEND_BASE_URL:"https://edc3-103-93-193-90.in.ngrok.io", //Harish Sir
  DISABLED_MENU: import.meta.env.VITE_DISABLED_MENU || "",
  ALLOWED_TIMEZONES: import.meta.env.VITE_ALLOWED_TIMEZONES?.split(",") || [],
  ALLOWED_LOCALES: import.meta.env.VITE_ALLOWED_LOCALES?.split(",") || [],
  PAYMENT_BATCHING_STRATEGIES: JSON.parse(import.meta.env.VITE_PAYMENT_BATCHING_STRATEGIES || "[]"),
  REPAYMENT_SETTLEMENT_STRATEGIES: JSON.parse(import.meta.env.VITE_REPAYMENT_SETTLEMENT_STRATEGIES || "[]"),
  CONSTITUTION_OF_BUSINESS: JSON.parse(import.meta.env.VITE_CONSTITUTION_OF_BUSINESS || "[]"),
  INTEREST_TYPES: JSON.parse(import.meta.env.VITE_INTEREST_TYPES || "[]"),
  INTEREST_LABEL: import.meta.env.VITE_INTEREST_LABEL,
  PROJECT_VERSION: import.meta.env.VITE_VERSION || "0.0.0",
  INSTRUMENT_DUE_DATE_CALCULATION_TYPES: JSON.parse(import.meta.env.VITE_INSTRUMENT_DUE_DATE_CALCULATION_TYPES || "[]"),
  BANK_LOGO: import.meta.env.VITE_BANK_LOGO || "vayana-logo.png",
  IS_BULK_MODULE_ENABLE: import.meta.env.VITE_ENABLE_BULK_ONBOARDING === "true",
  SHOW_BANK_LOGO: import.meta.env.VITE_SHOW_BANK_LOGO === "true",
  USER_SESSION_DURATION_IN_MINS : import.meta.env.VITE_USER_SESSION_DURATION_IN_MINS || 0,
  CHARGE_TYPES: JSON.parse(import.meta.env.VITE_CHARGE_TYPES || "[]"),
  DEFAULT_GST_PERCENTAGE: import.meta.env.VITE_DEFAULT_GST_PERCENTAGE || "18",
};
export default config;
